import { api } from '@/lib/api';
import { useQuery } from '@tanstack/react-query';
import { JobDetailedStatsResponse } from '../types';

interface FetchDetailedStatsParams {
  jobId: string;
  accountId: string;
  startDate: string;
  endDate: string;
}

/**
 * Fetch detailed stats from the API
 */
const fetchDetailedStats = async ({
  jobId,
  accountId,
  startDate,
  endDate,
}: FetchDetailedStatsParams): Promise<JobDetailedStatsResponse> => {
  const response = await api.get<JobDetailedStatsResponse>(
    `/v2/p2p/${jobId}/detailedstats?account_id=${accountId}&date_range=CUSTOM&start_date=${startDate}&end_date=${endDate}`
  );
  return response.data;
};

/**
 * Hook for fetching detailed job stats
 */
export const useDetailedStats = ({
  jobId,
  accountId,
  startDate,
  endDate,
}: FetchDetailedStatsParams) => {
  return useQuery<JobDetailedStatsResponse, Error>({
    queryKey: ['jobDetailedStats', jobId, accountId, startDate, endDate],
    queryFn: () => fetchDetailedStats({ jobId, accountId, startDate, endDate }),
    enabled: !!(jobId && accountId && startDate && endDate),
    staleTime: 10_000, // Cache for 10 seconds
  });
};
